import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
// nodejs library that concatenates classes
import classnames from "classnames";

// javascript plugin that creates nice dropzones for files
import Dropzone from "dropzone";
// reactstrap components
import {
    UncontrolledAlert,
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
} from "reactstrap";

// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
// react plugin that creates an input with badges
// import Sidebar from 'components/Sidebar/Sidebar';
import { createCustomers } from 'api/customerApiCall';
import { useTranslation } from '../../../i18n/context';

Dropzone.autoDiscover = false;

function AddCustomers() {
    const [sidenavOpen, setSidenavOpen] = React.useState(true);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [createdCustomerIds, setCreatedCustomerIds] = useState([]);
    const { t } = useTranslation();

    const francophoneCountries = [
        { code: 'gh', name: 'Ghana', dialCode: '233' },
        { code: 'BEN', name: 'Benin', dialCode: '229' },
        { code: 'BFA', name: 'Burkina Faso', dialCode: '226' },
        { code: 'TZA', name: 'Tanzania', dialCode: '255' },
        { code: 'BDI', name: 'Burundi', dialCode: '257' },
        { code: 'CMR', name: 'Cameroon', dialCode: '237' },
        { code: 'CAN', name: 'Canada', dialCode: '1' },
        { code: 'CAF', name: 'Central African Republic', dialCode: '236' },
        { code: 'TCD', name: 'Chad', dialCode: '235' },
        { code: 'COM', name: 'Comoros', dialCode: '269' },
        { code: 'COG', name: 'Congo', dialCode: '242' },
        { code: 'COD', name: 'DR Congo', dialCode: '243' },
        { code: 'DJI', name: 'Djibouti', dialCode: '253' },
        { code: 'FRA', name: 'France', dialCode: '33' },
        { code: 'GUF', name: 'French Guiana', dialCode: '594' },
        { code: 'PYF', name: 'French Polynesia', dialCode: '689' },
        { code: 'GAB', name: 'Gabon', dialCode: '241' },
        { code: 'GIN', name: 'Guinea', dialCode: '224' },
        { code: 'HTI', name: 'Haiti', dialCode: '509' },
        { code: 'CIV', name: "Côte d'Ivoire", dialCode: '225' },
        { code: 'LUX', name: 'Luxembourg', dialCode: '352' },
        { code: 'MDG', name: 'Madagascar', dialCode: '261' },
        { code: 'MLI', name: 'Mali', dialCode: '223' },
        { code: 'MRT', name: 'Mauritania', dialCode: '222' },
        { code: 'MCO', name: 'Monaco', dialCode: '377' },
        { code: 'NER', name: 'Niger', dialCode: '227' },
        { code: 'ng', name: 'Nigeria', dialCode: '234' },
        { code: 'RWA', name: 'Rwanda', dialCode: '250' },
        { code: 'SEN', name: 'Senegal', dialCode: '221' },
        { code: 'SYC', name: 'Seychelles', dialCode: '248' },
        { code: 'TGO', name: 'Togo', dialCode: '228' },
        { code: 'VUT', name: 'Vanuatu', dialCode: '678' }
    ];

    const navigate = useNavigate();
    const [customers, setCustomers] = useState([{
        companyId: '',
        customer_name: '',
        customer_email: '',
        customer_address: '',
        customer_country: '',
        customer_town: '',
        customer_phone: '',
        country_code: ''
    }]);
    const [error, setError] = useState(null);

    const toggleSidenav = () => {
        if (document.body.classList.contains("g-sidenav-pinned")) {
            document.body.classList.remove("g-sidenav-pinned");
            document.body.classList.add("g-sidenav-hidden");
        } else {
            document.body.classList.add("g-sidenav-pinned");
            document.body.classList.remove("g-sidenav-hidden");
        }
        setSidenavOpen(!sidenavOpen);
    };

    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        const newCustomers = [...customers];

        if (name === 'customer_country') {
            const selectedCountry = francophoneCountries.find(country => country.code === value);
            newCustomers[index]['customer_country'] = selectedCountry.name;
            newCustomers[index]['country_code'] = selectedCountry.dialCode;
        } else {
            newCustomers[index][name] = value;
        }

        setCustomers(newCustomers);
    };

    const formatPhoneNumber = (countryCode, phoneNumber) => {
        return `${countryCode} ${phoneNumber}`;
    };


    const addCustomer = () => {
        setCustomers([...customers, {
            companyId: '',
            customer_name: '',
            customer_email: '',
            customer_address: '',
            customer_country: '',
            customer_town: '',
            customer_phone: '',
            country_code: '',
        }]);
    };

    const removeCustomer = (index) => {
        const newCustomers = customers.filter((_, i) => i !== index);
        setCustomers(newCustomers);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const [errorCustomersCall, successUserCall] = await createCustomers(customers);
            if (errorCustomersCall) {
                setErrorMessages(errorCustomersCall.message);
                setShowErrorAlert(true);
            } else {
                const customerIds = successUserCall.map(customer => customer._id);
                setCreatedCustomerIds(customerIds);
                setShowSuccessAlert(true);
                setTimeout(() => {
                    navigate('/admin/customers');
                }, 2000);
            }
        } catch (error) {
            setErrorMessages([error.message]);
            setShowErrorAlert(true);
        }
    };


    return (
        <>
            <SimpleHeader name={t('customer.add_customer')} />

            <Container className="mt--6" fluid>
                <Row>
                    <Col lg="12">
                        <div className="card-wrapper">
                            <Card>
                                <CardHeader>
                                    <h3 className="mb-0">{t('customer.add_customer')}</h3>
                                    {showSuccessAlert && (
                                        <UncontrolledAlert color="success">
                                            <span className="alert-icon">
                                                <i className="ni ni-like-2" />
                                            </span>
                                            <span className="alert-text ml-1">
                                                <strong>{t('profile.success')}</strong> {t('customer.successful')}
                                            </span>
                                        </UncontrolledAlert>
                                    )}

                                    {showErrorAlert && (
                                        <UncontrolledAlert color="danger">
                                            <span className="alert-icon">
                                                <i className="ni ni-support-16" />
                                            </span>
                                            <span className="alert-text ml-1">
                                                <strong>{t('profile.error')}!</strong>{t('customer.not_successful')}
                                            </span>
                                        </UncontrolledAlert>
                                    )}
                                </CardHeader>
                                <CardBody>
                                    <Form onSubmit={handleSubmit}>
                                        {customers.map((customer, index) => (
                                            <div key={index}>
                                                <Row>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <InputGroup
                                                                className={classnames("input-group-merge", {
                                                                    // focused: yourName,
                                                                })}
                                                            >
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText>
                                                                        <i className="fas fa-user" />
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input
                                                                    placeholder={t('profile.name')}
                                                                    type="text"
                                                                    name="customer_name"
                                                                    id="customer_name"
                                                                    value={customer.customer_name}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    required

                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <InputGroup
                                                                className={classnames("input-group-merge", {
                                                                    // focused: emailAddress,
                                                                })}
                                                            >
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText>
                                                                        <i className="fas fa-envelope" />
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input
                                                                    placeholder="Email"
                                                                    type="email"
                                                                    name="customer_email"
                                                                    id="customer_email"
                                                                    value={customer.customer_email}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    required

                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <InputGroup className={classnames("input-group-merge")}>
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText>
                                                                        <i className="fas fa-globe" />
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input
                                                                    type="select"
                                                                    name="customer_country"
                                                                    id="customer_country"
                                                                    value={francophoneCountries.find(c => c.name === customer.customer_country)?.code || ''}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    required
                                                                >
                                                                    <option value="">{t('customer.select')}</option>
                                                                    {francophoneCountries.map(country => (
                                                                        <option key={country.code} value={country.code}>
                                                                            {country.name}
                                                                        </option>
                                                                    ))}
                                                                </Input>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <InputGroup className={classnames("input-group-merge")}>
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText>
                                                                        <i className="fas fa-phone" />
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                                <InputGroupText>
                                                                    {customer.country_code || '+XXX'}
                                                                </InputGroupText>
                                                                <Input
                                                                    placeholder={t('profile.phone')}
                                                                    type="tel"
                                                                    name="customer_phone"
                                                                    id="customer_phone"
                                                                    value={customer.customer_phone}
                                                                    maxLength={15}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (/^\d*$/.test(value) && value.length <= 15) {
                                                                            handleInputChange(index, e);
                                                                        }
                                                                    }}
                                                                    required
                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <InputGroup
                                                                className={classnames("input-group-merge", {
                                                                    // focused: emailAddress,
                                                                })}
                                                            >
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText>
                                                                        <i className="fas fa-globe" />
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input
                                                                    placeholder={t('customer.town')}
                                                                    name="customer_town"
                                                                    id="customer_town"
                                                                    value={customer.customer_town}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    required

                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="6">
                                                        <FormGroup>
                                                            <InputGroup
                                                                className={classnames("input-group-merge", {
                                                                    // focused: yourName,
                                                                })}
                                                            >
                                                                <InputGroupAddon addonType="prepend">
                                                                    <InputGroupText>
                                                                        <i className="fas fa-map-marker" />
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                                <Input
                                                                    placeholder={t('customer.address')}
                                                                    type="text"
                                                                    name="customer_address"
                                                                    id="customer_address"
                                                                    value={customer.customer_address}
                                                                    onChange={(e) => handleInputChange(index, e)}
                                                                    required

                                                                />
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                {index > 0 && (
                                                    <Button color="danger" onClick={() => removeCustomer(index)}>{t('category.remove')}</Button>
                                                )}
                                                <hr />
                                            </div>
                                        ))}
                                        <Button color="secondary" onClick={addCustomer}>{t('customer.add_another')}</Button>
                                        <Button className="btn-icon" color="primary" type="submit">
                                            <span className="btn-inner--text">{t('profile.submit')}</span>
                                        </Button>
                                    </Form>
                                </CardBody>
                            </Card>

                        </div>
                    </Col>
                </Row>
            </Container>
            {sidenavOpen ? (
                <div className="backdrop d-xl-none" onClick={toggleSidenav} />
            ) : null}
        </>
    );
}

export default AddCustomers;
